import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Modal } from '@mui/material';

import PreviewModal from 'components/PreviewModal/PreviewModal';

import { resetNotificationsService } from 'store/reducers/usersSlice';

const PreviewEmail = memo(({ openModal, onCloseModal, selectedEmail }) => {
  const dispatch = useDispatch();

  const [isFetchingEmail, setFetchingEmail] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(resetNotificationsService());
    };
  }, []);

  return (
    <Modal
      open={openModal}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;
        onCloseModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEscapeKeyDown
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          overflow: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
          maxHeight: 'calc(100vh - 100px)',
          maxWidth: 'calc(100vw - 24px)',
          minWidth: isFetchingEmail ? 'min(90vw, 800px)' : 'unset',
          minHeight: isFetchingEmail ? 'min(90vh, 800px)' : 'unset',
        }}
      >

        <PreviewModal
          modalTitle={selectedEmail?.subject}
          modalContent={selectedEmail?.body ?? <p>No Content</p>}
          modaldate={selectedEmail?.date}
          onCloseModal={onCloseModal}
        />

      </Box>
    </Modal>
  );
});

PreviewEmail.propTypes = {
  openModal: PropTypes.bool,
  onCloseModal: PropTypes.func,
  selectedEmail: PropTypes.object,
};

PreviewEmail.defaultProps = {
  openModal: false,
  onCloseModal: () => { },
  selectedEmail: null,
};
export default PreviewEmail;
